import React, { useState, useEffect } from 'react'
import styles from './Blog.module.css'
import Navbar1 from '../../Components/Navbar1/Navbar1'
import Carousel from '../../Components/Carousel/Carousel'
import { Link } from 'react-router-dom'
import axios from 'axios'

function Blog() {

    const [Et, setEt] = useState<any>("");
    const [Ws, setWs] = useState<any>("");

    useEffect(() => {
        const config: any = {
            method: 'get',
            url: 'http://localhost:3006/getblog',
            headers: {
                Authorization: "vgz2MtyLpVKBx1FVZ176CNp7XWUPpikK",
                'Content-Type': 'application/json'
            }
        }

        const employeeTransportationPosts: any = [];
        const whistleStoriesPosts: any = [];


        axios(config)
            .then((res) => {
                const details = res?.data
                details.forEach((post: any) => {
                    if (post.content_type === "Employee Transportation") {
                        employeeTransportationPosts.push(post);
                    } else if (post.content_type === "Whistle Stories") {
                        whistleStoriesPosts.push(post);
                    }
                });
                setEt(employeeTransportationPosts)
                setWs(whistleStoriesPosts)

                console.log(res)
            })
            .catch(err => {
                console.log(err)
            })

    }, [])


    return (
        <div className={styles.mainContainer}>
            <Navbar1 />
            <div className={styles.container}>
                <div className={styles.subContainer}>
                    <div className={styles.carouselContainer}>
                        <h3>Blog</h3>
                        <Carousel />
                    </div>
                    <div className={styles.headings}>
                        <h4>Employee Transportation</h4>
                        <h5>See all <i className='fas fa-angle-right'></i></h5>


                    </div>
                    <ul className={styles.blogsListContainer}>
                        {Et.length !== 0 ? (
                            Et.map((eachItem: any) => {
                                return (

                                    <li className={styles.blogCard}>
                                        <div>
                                            <img src={eachItem.card_img} alt='card-img'/>
                                            {/* <p>20 July 2023</p> */}
                                            <h4>{eachItem.title}</h4>
                                            <div className={styles.readMoreContainer}>
                                                <Link to={`/blogDetails/${eachItem.id}`} >Read More</Link>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })) : <p>no Data</p>
                        }

                    </ul>

                    <hr className={styles.line1} />

                    <div className={styles.headings}>
                        <h4>Whistle Stories</h4>
                        <h5>See all <i className='fas fa-angle-right'></i></h5>


                    </div>
                    <ul className={styles.blogsListContainer}>
                        {Ws.length !== 0 ? (
                            Ws.map((eachItem: any) => {
                                return (
                                    <li className={styles.blogCard}>
                                        <div>
                                            <img src={eachItem.card_img} alt='card-img' />
                                            {/* <p>20 July 2023</p> */}
                                            <h4>{eachItem.title}</h4>
                                            <div className={styles.readMoreContainer}>
                                                <Link to={`/blogDetails/${eachItem.id}`} >Read More</Link>
                                            </div>
                                        </div>
                                    </li>

                                )
                            })) : <p>no data</p>}
                    </ul>


                </div>


            </div>
        </div>
    )
}

export default Blog
